export const MY_EQUIPMENT_TAG = 'MY_EQUIPMENT';
export const SEARCH_KEYS = [
  'serialNumber',
  'name',
  'equipmentFamily',
  'assetId',
  'model'
];

export const MY_EQUIPMENT_SEARCH_KEYS = [
  'serialNumber',
  'equipmentFamily',
  'assetName',
  'name',
  'model',
  'productFamily'
];

export const ITEMS_PER_PAGE = 50;

export const CURRENT_EQUIPMENT_RESPONSE = {
  isError: false,
  equipment: null,
  myEquipmentList: [],
  selectedEquipmentIndex: -1,
  isEquipmentSelected: false,
  isNotFound: false
};
